@if (imageUrl) {
    @if (confidenceScore) {
        <div
            class="confidence-score"
            matTooltip="Confidence">
            <span>{{ confidenceScore * 100 | number: "1.0-1" }}%</span>
        </div>
    }
    @defer (when imageUrl) {
        <img
            [src]="imageUrl"
            [alt]="alt" />
    } @placeholder {
        <mat-progress-spinner></mat-progress-spinner>
    }
}
<div
    class="plant-info"
    matTooltip="{{ scientificName }} ({{ commonNames }})">
    <span class="name scientific">
        {{ scientificName }}
    </span>
    @if (commonNames) {
        <span class="name common">{{ commonNames }}</span>
    }
</div>
